export const TRY_DEMO = "/try-demo";
export const MAIN_PAGE = "/";
export const AUTH_PAGE = "/auth/login";
export const AUTH_SIGN_UP = "/auth/signup";
export const PWA_PAGE = "/pwa";
export const FAQ_PAGE = "/faq";
export const AFFILIATE_PROGRAM_PAGE = "/affiliate-program";
export const SUPPORT_PAGE = "/support";
export const TOOLS_PAGE = "/tools";
export const ABOUT_US_PAGE = "/about-us";
export const PWA_MACOSPAGE = "/pwa-macos";
export const PRIVACY_POLICY = "/privacy-policy";
export const TERMS_CONDITIONS = "/terms-conditions";
export const RISK_DISCLOSURE = "/risk-disclosure";
export const COOKIE_POLICY = "/cookie-policy";
export const UNSUBSCRIBE = "/mail/unsubscribe";

